/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer components {
  .notification {
    border-radius: var(--radius-sm, 0.25rem);
    &:global(.ant-notification-notice-success) {
      background-color: var(--base-green-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--base-green-600);
      }
    }
    &:global(.ant-notification-notice-info) {
      background-color: var(--base-blue-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--base-blue-600);
      }
    }
    &:global(.ant-notification-notice-warning) {
      background-color: var(--base-yellow-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--base-yellow-600);
      }
    }
    &:global(.ant-notification-notice-error) {
      background-color: var(--base-red-100);
      & :global(.ant-notification-notice-icon) {
        color: var(--base-red-500);
      }
    }
  }
}
